import { useMutation } from "@tanstack/react-query"
import { postFeedBack } from "./axiosQuery/feedbackQuery"

// mutation
export const usePostFeedBack = () => {
    return (
        useMutation({
            mutationFn: (data) => postFeedBack(data),
            onError: (e) => {
                console.log({e});
            },
        })
    )
}